@let mergeAuthCount = (mergeAuthCount$ | async)?.length ?? 0;
@let mergePublisherCount = (mergePublisherCount$ | async)?.length ?? 0;
@let mergeBookCount = (mergeBookCount$ | async)?.length ?? 0;

<section class="h-full flex flex-wrap justify-between w-full min-[767.98px]:w-[1136px] mx-auto duration-200 bg-white dark:bg-gray-900">
  <!-- ? Header is Fixed in top and In all Pages -->
  <header class="hidden w-screen sm:flex h-24 flex-wrap items-center justify-between sticky top-0 z-50 bg-white dark:bg-gray-900">
    <!-- ? Logo Container -->
    <div class="sm:w-3/12 lg:w-44 sm:flex h-24 px-2 items-center border-gray-100 dark:border-gray-600 border-l-[1px]">
      <a class="cursor-pointer" width="112px" height="38.34px" alt="بهخوان" id="behkhaanLogo" [routerLink]="['/feeds']"> </a>
    </div>

    <!-- ? Search Bar Container -->
    <div class="h-24 w-fit grow p-4 flex items-center justify-center border-b border-gray-100 dark:border-gray-600">
      <beh-layout-search
        class="w-full"
        [result]="result"
        [loading]="loadingResult"
        (termChanged)="search($event)"
        (navigateToSearch)="navigateToSearchPage($event)"
        (followUser)="FollowClicked($event)"></beh-layout-search>
    </div>

    <!-- ? User Info And Actions -->
    <div class="hidden lg:h-24 lg:w-[272px] lg:flex lg:items-center lg:justify-end lg:pr-4 border-gray-100 dark:border-gray-600 border-r-[1px]">
      <!-- ? login button -->
      <ng-container *ngIf="!currentUser; else userTemplate">
        <button class="btn-sm bg-green-500 text-white dark:text-black" (click)="openSignin()" id="loginBtn">ثبت‌نام | ورود</button>
      </ng-container>

      <!-- ? User Actions -->
      <ng-template #userTemplate>
        <div class="w-full flex items-center justify-between">
          <!-- ? User Detail -->
          <div class="grow flex">
            <a class="w-full flex items-center cursor-pointer" [routerLink]="[routes.profile, currentUser?.uniqeName]">
              @if (profileImage) {
                <img
                  loading="lazy"
                  class="avatar-md"
                  [src]="profileImage"
                  [alt]="currentUser?.firstName"
                  onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'" />

              } @else {
                <img
                  loading="lazy"
                  class="avatar-md"
                  [src]="currentUser?.id | image: imageType.userAvatar: currentUser?.hasPhoto"
                  [alt]="currentUser?.firstName"
                  onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'" />
              }

              <div class="w-full px-2 grow flex flex-wrap">
                <p class="w-full text-sm text-gray-900">
                  {{ currentUser?.firstName }}
                </p>
                <p class="text-sm text-gray-900 text-right" dir="ltr">
                  {{ "@" + currentUser?.uniqeName }}
                </p>
              </div>
            </a>
          </div>

          <!-- ? Actions -->
          <button class="icon-btn" (click)="logout()">
            <span class="icon arrow-exit-regular text-gray-900 text-2xl"></span>
          </button>
        </div>
      </ng-template>
    </div>
  </header>

  <!-- ? Main is Seperated By Two Article -->
  <main
    [ngClass]="{ '!h-[calc(100%-56px)]': currentUser && !(router.url.includes('donate') || router.url.includes('annual-report')) }"
    class="h-full lg:!h-[calc(100%-96px)] w-screen min-[1136px]:w-full flex items-start justify-between">
    <!-- ? Menu -->
    <article
      class="hidden sm:w-3/12 lg:w-44 lg:min-w-44 sm:h-[calc(100dvh-6rem)] sm:flex sm:content-start sm:items-start sm:px-2 sm:border-l sm:border-gray-100 dark:sm:border-gray-600 sm:sticky sm:top-24 z-[1000]">
      <div class="w-full flex flex-wrap items-center">
        @for (menu of sidenavItems; track $index) {
          <div class="w-full h-10 xl:h-12 outline-none flex items-center justify-center text-gray-900">
            <!-- main navigation item -->
            <app-sidenav-menu-item
              class="w-full"
              [notificationCount]="notificationCount"
              [displayCount]="false"
              [item]="menu"
              [matMenuTriggerFor]="menu.type === eSlidenavMenu.More ? menuDropdown : null"
              #menuTrigger="matMenuTrigger"
              yPosition="above"
              (click)="onSidenavItemClicked(menu, menuTrigger)">
            </app-sidenav-menu-item>

            <!-- material submenu -->
            <mat-menu class="!w-[240px] !h-40 !rounded-xl" #menuDropdown="matMenu">
              @for (child of menu.children; track child) {
                <a mat-menu-item [routerLink]="child.link ? [child.link] : []" [queryParams]="child.query" class="flex items-center justify-between text-gray-900">
                  <div class="flex items-center" [ngClass]="{ '!text-gray-900': !child.link }" [routerLinkActive]="['text-green-500']" [routerLinkActiveOptions]="{ exact: true }">
                    <!-- ? Icon -->
                    <span class="icon text-xl" [ngClass]="child.icon"></span>

                    <!-- ? Titale -->
                    <span class="text-sm mr-2">
                      {{ child.title }}
                    </span>
                  </div>
                </a>
              }
            </mat-menu>
          </div>
        }

        <!-- ? Merge Author -->
        <ng-container *ngIf="currentUser?.isLibrarian && mergeAuthCount > 0">
          <div class="w-full flex items-center relative cursor-pointer mt-2" (click)="openMergeDialog()">
            <span class="icon text-gray-900 table-move-right-regular text-xl"></span>
            <span class="grow flex justify-start items-center text-sm g text-gray-900 mr-2">
              تلفیق نویسنده
              <span class="rounded-full mr-2 text-sm w-[17px] h-[17px] flex flex-wrap content-center justify-center bg-red-700 text-white" *ngIf="mergeAuthCount > 0">
                {{ mergeAuthCount }}
              </span>
            </span>
          </div>
        </ng-container>

        <!-- ? Merge Publisher -->
        <ng-container *ngIf="currentUser?.isLibrarian && mergePublisherCount > 0">
          <div class="w-full flex items-center relative cursor-pointer mt-2" (click)="openMergeDialog()">
            <span class="icon text-gray-900 table-move-right-regular text-xl"></span>
            <span class="grow flex justify-start items-center text-sm g text-gray-900 mr-2">
              تلفیق ناشر
              <span class="rounded-full mr-2 text-sm w-[17px] h-[17px] flex flex-wrap content-center justify-center bg-red-700 text-white" *ngIf="mergePublisherCount > 0">
                {{ mergePublisherCount }}
              </span>
            </span>
          </div>
        </ng-container>

        <!-- ? Merge Book -->
        <ng-container *ngIf="currentUser?.isLibrarian && mergeBookCount > 0">
          <div class="w-full flex items-center relative cursor-pointer mt-2" (click)="openMergeDialog()">
            <span class="icon text-gray-900 Merge text-xl"></span>
            <span class="grow flex justify-start items-center text-sm g text-gray-900 mr-2">
              تلفیق کتاب
              @if (mergeBookCount > 0) {
                <span class="rounded-full mr-2 text-sm w-[17px] h-[17px] flex flex-wrap content-center justify-center bg-red-700 text-white">
                  {{ mergeBookCount }}
                </span>
              }
            </span>
          </div>
        </ng-container>

        @if (currentUser) {
          <a [routerLink]="[routes.predonation]" class="flex w-full items-center justify-center btn-green-mute mt-3">
            <span class="icon ri_candle-line text-xl text-green-500"></span>
            <!-- ? Title -->
            <span class="text-sm font-normal mr-2 text-green-500"> حمایت مالی </span>
          </a>
        }
      </div>

      @if (currentUser) {
        <div class="min-h-12 min-w-12 max-w-[90%] flex absolute bottom-4">
          <app-floating-actions class="w-full" [displayActions]="false" [displayAdd]="true"></app-floating-actions>
        </div>
      }
    </article>

    <!-- ? Router Content -->
    <!-- * max-[639px]:w-full min-[640px]:w-[80%] min-[767.98px]:!w-7/12 -->
    <article class="h-full flex flex-1 max-[639px]:w-full min-[640px]:w-8/12 min-[767.98px]:!w-7/12 max-w-full items-center justify-center">
      <div id="scrollableLayout" class="h-full w-full relative overflow-auto hide-scroll">
        <div class="w-full h-full" [@routeTransition]="prepareRoute(outlet)" (@routeTransition.done)="onAnimationDone()">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </article>

    <article
      class="hidden lg:w-[272px] lg:min-w-[272px] lg:flex lg:flex-wrap px-2 lg:pl-2 lg:pr-4 sticky top-24 content-start justify-end h-[calc(100dvh-6rem)] items-start border-r border-gray-100 dark:border-gray-600 overflow-auto hide-scroll">
      @if (currentUser && Repository.IsInBrowser) {

        @if (displaySetAvatar) {
          <app-behkhaan-suggestion-set-avatar class="w-full mb-4 h-[106px]" (close)="removeSetAvatarCard($event)"> </app-behkhaan-suggestion-set-avatar>
        }
        <app-home-currently-reading class="w-full"></app-home-currently-reading>
      }


    </article>
  </main>

  <!-- ! dont remove -->
  <!-- <div
    *ngIf="uploadEvent?.status == uploadStatusEnum.started || uploadEvent?.status == uploadStatusEnum.uploading || uploadEvent?.status == uploadStatusEnum.finished "
    class="flex flex-wrap justify-center upload-progress">
    <app-media-upload-progress class="w-full" [mediaType]="uploadEvent.mediatype"></app-media-upload-progress>
  </div> -->

  <!-- ? Footer -- Just For Mobile -->
  <ng-container *ngIf="currentUser && !(router.url.includes('donate') || router.url.includes('annual-report'))">
    <footer class="w-full flex-wrap flex lg:hidden items-center justify-between border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 fixed bottom-0 z-50 py-1">
      <!-- TODO: create items list and itterate this list to display items -->

      <!-- ? Profile -->
      <a
        class="text-xs cursor-pointer w-1/5 flex items-center justify-center h-12 outline-none text-gray-700"
        [routerLink]="[routes.profile, currentUser?.uniqeName]"
        [routerLinkActive]="['!text-green-500']">
        <span class="icon person-regular text-3xl ml-1"></span>
      </a>

      <!-- ? Notification -->
      <a class="text-xs cursor-pointer w-1/5 flex items-center justify-center h-12 outline-none text-gray-700 relative" [routerLink]="[routes.notifications]" [routerLinkActive]="['!text-green-500']">
        <span class="relative flex">
          <span class="absolute bottom-4 left-6 w-[15px] h-[15px] rounded-full flex items-center justify-center text-white text-[0.65rem] text-center bg-red-700" *ngIf="notificationCount">{{
            notificationCount > 9 ? "+9" : notificationCount
          }}</span>
          <span class="icon alert-regular text-3xl ml-1"></span>
        </span>
      </a>

      <!-- ? Actions -->
      <div class="w-1/5 flex items-center justify-center h-11 outline-none text-gray-700">
        <button
          class="w-10 h-10 flex items-center justify-center border-[1.5px] border-gray-700 dark:border-gray-200 p-2 rounded-full"
          [ngClass]="{ 'btn-add--active': displayActions }"
          (click)="actionButtonsMobile()">
          <span class="icon add-regular duration-300 text-2xl" [ngClass]="{ 'transform rotate-45': displayActions }"></span>
        </button>
      </div>

      <!-- ? Search -->
      <a class="text-sm cursor-pointer w-1/5 flex items-center justify-center h-12 outline-none text-gray-700" [routerLink]="[routes.explore]" [routerLinkActive]="['!text-green-500']">
        <span class="icon search-regular text-3xl"></span>
      </a>

      <!-- ? Feeds -->
      <a class="text-sm cursor-pointer w-1/5 flex items-center justify-center h-12 outline-none text-gray-700" [routerLink]="[routes.feed]" [routerLinkActive]="['!text-green-500']">
        <span class="icon home-regular text-3xl ml-1"></span>
      </a>
    </footer>
  </ng-container>
</section>

<ng-template #loadingTemplate>
  <ngx-skeleton-loader class="flex w-full h-12 outline-none" [theme]="{ height: '100%', width: '100%' }"> </ngx-skeleton-loader>
</ng-template>

@if (messagingLoading) {
  <app-loading></app-loading>
}
